// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import SideMenu from '../component/SideMenu';
import type { Characteritics } from '../../../types/OfficesType';

type Props = {
  services: Characteritics[],
}

type State = {
  itemSelected: string,
}

class Services extends React.Component<Props, State> {
  state: State = {
    itemSelected: this.props.services.length > 0 ? this.props.services[0].characteristicsType.label : '',
  };

  shouldComponentUpdate(nextProps: Props, nextState: State): boolean {
    if (nextProps.services !== this.props.services && nextProps.services.length > 0) {
      nextState.itemSelected = nextProps.services[0].characteristicsType.label;
    }
    return true;
  }

  onItemSelected = (itemSelected: string) => {
    this.setState({ itemSelected });
  };

  getDataItems = () => this.props.services.map(service => service.characteristicsType.label);

  render() {
    return (
      <div className="building-description">
        <div className="title">
          <Translate value="OFFICE.SERVICE" />
        </div>
        {
          (this.props.services && this.props.services.length > 0)
            ? (
              <SideMenu
                bottomAlign
                items={this.getDataItems()}
                itemSelected={this.state.itemSelected}
                onItemSelected={this.onItemSelected}
              >
                <div className="data">
                  {
                    this.props.services
                      .filter((service: Characteritics) =>
                        this.state.itemSelected === service.characteristicsType.label)
                      .map((service: Characteritics) =>
                        (<div
                          key={service.characteristicsType.id}
                          dangerouslySetInnerHTML={{ __html: service.value }}
                        />))
                  }
                </div>
              </SideMenu>
            ) : (
              <div className="empty-state">
                <Translate value="OFFICE.NO_SERVICE" />
              </div>
            )
        }
      </div>
    );
  }
}

export default Services;
